import axios from "axios";
import { checkAndRefreshToken } from "./authUtils.js";
import { toast } from "react-toastify";

export const API_URL = process.env.REACT_APP_API_URL;

let rateLimitToastId = null;

const API = axios.create({
  baseURL: API_URL + "/api/v1",
  withCredentials: true,
});

// Request interceptor
API.interceptors.request.use(
  async (request) => {
    const unAuthAccessRoutes = ["login", "refresh-token"];
    const isAuthPage = window.location.pathname === "/login";
    if (isAuthPage || unAuthAccessRoutes.some(route => request.url.endsWith(route))) {
      return request;
    }

    const token = await checkAndRefreshToken();
    if (token) {
      request.headers["authorization"] = `Bearer ${token}`;
    }

    // Add refresh token to header if available in sessionStorage (incognito fallback)
    const refreshToken = sessionStorage.getItem("refreshToken");
    if (refreshToken) {
      request.headers["x-refresh-token"] = refreshToken;
    }

    request.headers["Content-Type"] = request.headers['Content-Type'] || "application/json";
    return request;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const isRefreshUrl = error?.config?.url?.endsWith("refresh-token");

    if (error?.response?.status === 401 && isRefreshUrl) {
      sessionStorage.removeItem("refreshToken");

      // stop infinite reload
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }

        return Promise.reject(error);
    }

    if (error?.response?.status === 429) {
      if (!toast.isActive(rateLimitToastId)) {
        rateLimitToastId = toast.error(
          "Too many requests. Please try again in some time.",
          { toastId: "rate-limit-error" }
        );
      }
    }

    return Promise.reject(error);
  }
);

export default API;
